import { useMemo } from 'react';

import { useBuyingPlanRows } from './useGetBuyingPlanData.js';

const useLastRowOfChannelIds = () => {
  const rows = useBuyingPlanRows();

  return useMemo(() => {
    const result: number[] = [];

    rows?.forEach((channelRow) => {
      if (channelRow.subItems?.length) {
        const lastPlatform =
          channelRow.subItems[channelRow.subItems.length - 1];

        if (lastPlatform.subItems?.length) {
          const lastTileRowId =
            lastPlatform.subItems[lastPlatform.subItems.length - 1].id;
          if (lastTileRowId) {
            result.push(lastTileRowId);
          }
        } else {
          lastPlatform.id && result.push(lastPlatform.id);
        }
      }
    });

    return result;
  }, [rows]);
};

export default useLastRowOfChannelIds;
